export const REPORT_TYPES_SLOT_KEY = '__report-types__'

export const REPORT_TYPES_SLOT = { key: REPORT_TYPES_SLOT_KEY }
